import { React, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useShirtArea } from "../../hooks";
const CommonShirtImage = ({ style = {}, imageStyle = {} }) => {
  const { areas, selectedProUrl } = useShirtArea();
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setIsLoading(true);
  }, []);
  return (
    <div style={{ margin: "14px 10px" }}>
      <div
        className="right-chest-full"
        style={{
          height: 528,
          border: "0.5px solid grey",
          backgroundColor: "#f2f2f2",
          ...style,
        }}
      >
        {isLoading && (
          <div className="loader">
            <Spinner
              style={{
                width: "40px",
                height: "40px",
                borderWidth: 2,
              }}
            />
          </div>
        )}
        <img
          src={selectedProUrl || areas?.chest_right?.url}
          alt="Zoomable"
          style={{
            ...imageStyle,
          }}
          onLoad={() => setIsLoading(false)}
        />
      </div>
    </div>
  );
};

export default CommonShirtImage;
